import { useQuery } from '@tanstack/react-query';
import { api } from './client';

export interface ClusterItem {
  feedLabel: string;
  feedUrl: string;
  title: string;
  url: string;
  publishedAt: string | null;
  observedAt: string;
}

export interface StoryCluster {
  id: string;
  sources: string[];
  items: ClusterItem[];
  oldestAt: string | null;
  latestAt: string | null;
  /** One-sentence Groq-generated summary; null when LLM is off or summarisation
   *  was skipped (cluster is past the per-request cap). */
  summary: string | null;
}

export interface NewsDeskClustersResponse {
  config: {
    windowHours: number;
    minSources: number;
    llmConfigured: boolean;
  };
  cache: { items: number; lastRefreshAt: string | null };
  clusters: StoryCluster[];
}

export function useStoryClusters(params: {
  windowHours?: number;
  minSources?: number;
  summaries?: boolean;
}) {
  return useQuery({
    queryKey: ['news-desk-clusters', params],
    // Refetch every 5 min — the underlying cache itself refreshes every 10 min,
    // but story membership can shift faster as new items echo into existing clusters.
    refetchInterval: 5 * 60_000,
    queryFn: () =>
      api.get<NewsDeskClustersResponse>('/admin/news-desk-clusters', {
        ...(params.windowHours ? { windowHours: params.windowHours } : {}),
        ...(params.minSources ? { minSources: params.minSources } : {}),
        ...(params.summaries ? { summaries: '1' } : {}),
      }),
  });
}
